import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';
import { GtagMetricComponent } from '../gtag-metric/gtag-metric.component';

@Component({
  selector: 'app-lazy-metric-gtag',
  standalone: true,
  imports: [CommonModule, GtagMetricComponent],
  templateUrl: './lazy-metric-gtag.component.html',
})
export class LazyMetricGtagComponent {
  googleTagManagerCodes$: Observable<string[] | null | undefined> = inject(ConfigRepository).googleTagManagerCodes$;
}
